module.exports = __webpack_public_path__ + "img/case1.b07163a8.jpg";